import { Button, Loader } from '@recruit-robin/robin-theme/web-components';
import { useContext } from 'react';
import { useContextSelector } from 'use-context-selector';

import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { EnrichVacancyModalContext } from '../EnrichVacancyModalContext/EnrichVacancyModalContext';
import { EnrichVacancyModalState } from '../EnrichVacancyModalContext/EnrichVacancyModalContext.types';
import { useSubmit } from './useSubmit';

export const SubmitButton = () => {
  const { dictionary } = useContext(LocalizationContext);

  const state = useContextSelector(EnrichVacancyModalContext, (s) => s.state);
  const { handleSaveAndSubmit, isSubmitting } = useSubmit();

  if (state === EnrichVacancyModalState.EnrichingVacancy || state === EnrichVacancyModalState.ChoosingCreationMethod) {
    return null;
  }

  return (
    <Button
      style="filled"
      type="default"
      onClick={handleSaveAndSubmit}
      label={dictionary.saveAndSubmit}
      disabled={isSubmitting}
      startIcon={isSubmitting ? <Loader size={16} color={(c) => c.secondary.sky} /> : undefined}
    />
  );
};
